import React, { PureComponent } from 'react';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class PaymentDataForm extends PureComponent {
  constructor(props) {
    super(props);
    if (props.paymentData) {
      this.state = { ...props.paymentData };
    } else {
      this.state = {};
    }
  }

  render = () => {
    const {
      totalAmountDue, pastAmountDue, dueDate, lastPaymentDate,
      lastPaymentAmount, tpsTransactionId,
    } = this.state;

    return (
      <Form>
        <Form.Row>

        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="tpsTransactionId">
              <Form.Label>TPS Transaction ID</Form.Label>
              <Form.Control readOnly type="text" value={tpsTransactionId || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="totalAmountDue">
              <Form.Label>Total Amount Due</Form.Label>
              <Form.Control readOnly type="text" value={totalAmountDue || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="dueDate">
              <Form.Label>Due Date</Form.Label>
              <Form.Control readOnly type="text" value={dueDate || '-'} />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="pastAmountDue">
              <Form.Label>Past Amount Due</Form.Label>
              <Form.Control readOnly type="text" value={pastAmountDue || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastPaymentDate">
              <Form.Label>Last Payment Date</Form.Label>
              <Form.Control readOnly type="text" value={lastPaymentDate || '-'} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastPaymentAmount">
              <Form.Label>Last Payment Amount</Form.Label>
              <Form.Control readOnly type="text" value={lastPaymentAmount || '-'} />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

PaymentDataForm.propTypes = {
  paymentData: Shapes.PAYMENT_DATA,
};

PaymentDataForm.defaultProps = {
  paymentData: null,
};

export default PaymentDataForm;
